import {
  UPDATE_ORDER,
  UPDATE_SHOP_SETTING,
  UPDATE_USER,
  UPDATE_ORDER_COUNT,
  UPDATE_CURRENT_ADDRESS,
  IS_FETCH_USER,
  UPDATE_CURRENT_LOCATION,
  UPDATE_LOADER_GOOGLE,
  UPDATE_SETTINGS,
  APPLY_PROMOTION,
  SPENING,
  GET_ORDER_SERVICE_DETAIL,
} from './action';

const reducer = (
  state = {
    user: {},
    isFetchedUser: false,
    orderCount: 0,
    currentAddress: [],
    currentLocation: { lat: 0, long: 0 },
    google: null,
    settings: {},
    order: {},
    applyPromotion: {},
    spening: false,
    orderServiceDetail: {}
  },
  action
) => {
  if (action.type === UPDATE_ORDER) {
    return {
      ...state,
      order: action.data,
    };
  }

  if (action.type === UPDATE_SHOP_SETTING) {
    return {
      ...state,
      shop_setting: action.data,
    };
  }

  if (action.type === APPLY_PROMOTION) {
    return {
      ...state,
      applyPromotion: action.data,
    };
  }

  if (action.type === SPENING) {
    return {
      ...state,
      spening: action.data,
    };
  }

  if (action.type === GET_ORDER_SERVICE_DETAIL) {
    return {
      ...state,
      orderServiceDetail: action.data,
    };
  }

  switch (action.type) {
    case UPDATE_USER:
      return {
        ...state,
        user: action.data,
      };
    case UPDATE_ORDER_COUNT:
      return {
        ...state,
        orderCount: action.data,
      };
    case UPDATE_CURRENT_ADDRESS:
      return {
        ...state,
        currentAddress: action.data,
      };
    case IS_FETCH_USER:
      return {
        ...state,
        isFetchedUser: action.data,
      };
    case UPDATE_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.data,
      };
    case UPDATE_LOADER_GOOGLE:
      return {
        ...state,
        google: action.data,
      };
    case UPDATE_SETTINGS:
      return {
        ...state,
        settings: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
